// extracted by mini-css-extract-plugin
export default {"lockedWarning":"Pos1dOWMs3M_YwJ39Uj0","lockIcon":"y_JxAyc7qKkFcpTKRrh9","button":"qpxVDwKhENaJU0J5Peb8"};